import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  cardRoot: {
    width: '100%',
    minWidth: 300,
    margin: theme.spacing(1, 0),
    borderRadius: theme.spacing(0.5),
    background: 'none',
    [theme.breakpoints.up('sm')]: {
      width: 400,
    },
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2),
    },
  },

  cardContent: {
    padding: theme.spacing(2, 0, 0, 0),
    textAlign: 'center',
  },

  cardTitle: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.mainAlternative,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.h6.fontSize,
    },
  },
  imgContainer: {},

  cardButton: {
    width: '100%',
    padding: theme.spacing(2, 1),
    justifyContent: 'flex-end',
    '& span': {
      backgroundImage: `linear-gradient(120deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 100%)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 0.2em',
      backgroundPosition: '0 110%',
      transition: 'background-size 0.25s ease-in',
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.disabled,
      [theme.breakpoints.up('sm')]: {
        cursor: 'pointer',
      },
    },
  },

  cardInfoWrapper: {
    justifyContent: 'space-between',
    padding: theme.spacing(1),
  },

  cardInfo: {
    flexShrink: 1,
    flexGrow: 0,
    '& span': {
      fontSize: theme.typography.caption.fontSize,
      fontWeight: theme.typography.fontWeightLight,
      color: theme.palette.text.disabled,
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.body2.fontSize,
      },
    },
  },

  image: {
    border: `1px solid ${theme.palette.background.lightOverlay}`,
    width: '100%',
    height: `${
      typeof window !== 'undefined' ? window.innerWidth - 64 - 16 : 0
    }px`,
    position: 'relative',
    zIndex: 1,
    borderRadius: theme.spacing(0.5),
    boxShadow: theme.shadows[0],
    [theme.breakpoints.up('sm')]: {
      height: 384,
    },
  },
  blogTitle: {
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 60,
    background: theme.palette.background.overlay,
    zIndex: 2,
    borderBottomRightRadius: theme.spacing(0.5),
    borderBottomLeftRadius: theme.spacing(0.5),
    '& span': {
      color: theme.palette.text.white,
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.fontWeightBold,
    },
  },
}))
